<template>
  <div class="social-sharing">
    <div class="social-sharing-inner">
      <button type="button" class="exit-button" @click="close()"><rp-sprite class="exit-icon" name="close"/></button>

      <div class="sharing-options-container">
        <div class="sharing-option-container" @click="selected=1">
          <rp-sharing-option
            ref="option-1"
            :numberValue="numberValue"
            :numberFrom="numberFrom"
            :label="label"/>

            <div class="sharing-radio-button">
              <div class="sharing-selected-button" v-if="selected==1"/>
            </div>
          <!-- <input type="radio" class="radio" value="1" v-model="selected"> -->
        </div>

        <div class="sharing-option-container" @click="selected=2">
          <rp-sharing-option
            ref="option-2"
            :numberValue="numberValue"
            :numberFrom="numberFrom"
            :label="label"
            light/>

          <div class="sharing-radio-button">
            <div class="sharing-selected-button" v-if="selected==2"/>
          </div>
          <!-- <input type="radio" class="radio" value="2" v-model="selected"> -->
        </div>
      </div>

      <div class="social-button-container">
        <rp-button class="share-button" type="primary" @click="makeAction('shareOnFacebook')">
          <rp-sprite class="facebook-icon" name="facebook"/>
          Share on Facebook
        </rp-button>
        <rp-button class="share-button" type="primary" @click="makeAction('shareOnLinkedIn')">
          <rp-sprite class="linkedin-icon" name="linkedin"/>
          Share on LinkedIn
        </rp-button>
        <rp-button class="share-button" type="primary" @click="makeAction('downloadImage')">
          <rp-sprite class="download-icon" name="get_app"/>
          Download image
        </rp-button>
      </div>
    </div>
  </div>
</template>

<script>
  import Button from '../../../../components/ui/inputs/Button'
  import Sprite from '../../../../components/ui/Sprite'
  import Option from './Option'

  export default {
    components: {
      'rp-button': Button,
      'rp-sprite': Sprite,
      'rp-sharing-option': Option
    },

    name: 'SocialSharingForm',

    props: {
      numberValue: Number,
      numberFrom: Number,
      label: String
    },

    data() {
      return {
        canvas: null,
        selected: '1'
      }
    },

    methods: {
      close() {
        this.$emit('close');
      },

      makeAction(actionName) {
        this.$refs[`option-${this.selected}`][actionName]()
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../../../styles/main.sass'

.social-sharing
  max-height: 500px
  overflow-y: scroll

  .social-sharing-inner
    display: flex
    flex-direction: column
    margin: 0 20px
    position: relative
    width: 90vw
    max-width: 700px
    transition: opacity 0.2s
    background-color: white
    border-radius: 2px
    box-shadow: 2px 3px 5px 0px rgba(0,0,0,0.25)
    padding: 60px 20px 30px

    &.hide
      opacity: 0

    .exit-button
      position: absolute
      right: 5px
      top: 5px
      padding: 10px
      border: 0
      background-color: white

      .exit-icon
        width: 24px
        height: 24px
        fill: grey

    .social-button-container
      display: flex
      justify-content: center
      flex-wrap: wrap
      margin-top: -10px

      button
        margin: 10px 5px 0
        padding-left: 15px
        display: flex
        align-items: center

        svg
          margin: 0 7px 0 0
          
          &.facebook-icon
            width: 7px
            height: 14px

          &.linkedin-icon
            width: 11px
            height: 11px
            margin-bottom: 2px
          
          &.code-icon
            width: 14px
            height: 8px

    .sharing-options-container
      display: flex
      width: 100%
      justify-content: space-between
      margin-bottom: 30px
      // flex-wrap: wrap

      @media screen and (max-width: 800px)
        flex-direction: column
        align-items: center

      .sharing-option-container
        // width: calc(50% - 8px)
        margin-top: 10px
        position: relative
        cursor: pointer

        @media screen and (max-width: 800px)
          width: 100%

        .sharing-radio-button
          position: absolute
          bottom: 20px
          left: 0
          right: 0
          margin: auto
          width: 20px
          height: 20px
          border-radius: 50%
          background-color: white
          display: flex
          align-items: center
          justify-content: center

          .sharing-selected-button
            width: 14px
            height: 14px
            border-radius: 50%
            background-color: #8BC34A


</style>


// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/SocialSharing/index.vue